<template>
  <div>
    <div class="col-md-6">
      <button name="investor-profile"
              type="button"
              class="btn btn-blue"
              @click="profile">Create Investor Profile
      </button>
      <button name="investor-view"
              type="button"
              class="btn btn-blue"
              @click="viewInvestor">Investors
      </button>
      <button name="client-view"
              type="button"
              class="btn btn-blue"
              @click="viewClient">Invited Investors
      </button>
      <button name="client-view"
              type="button"
              class="btn btn-blue"
              @click="viewImport">Import Investors
      </button>
      <div v-if="isVisible">
          <br/><br/>
          <investor-profile :locationOptions="locale" @profile-created="getProfileData"></investor-profile>
        <label>Invite to:</label>
        <div class="radio radio-primary">
          <input type="radio" name="Invite_to" value="offering" v-model="inviteTo" @change="selectVisible"/>
          <label>Offering</label>
          </div>
        <div class="radio radio-primary">
          <input type="radio" name="Invite_to" value="docflow" v-model="inviteTo" @change="selectVisible"/>
          <label>Document Flow</label>
        </div>
          <investor-offering v-if="offeringInviteVisible" :offering-list="offerings" :profile-data="profileData" @offering-saved="getOfferingData"></investor-offering>
          <investor-document-flow v-if="documentInviteVisible" :doc-flow-list="docFlows" :profile-data="profileData" @docflow-saved="getDocFlowData"></investor-document-flow>
      </div>
    </div>
    <div class="col-md-6 pull-right">
      <br/><br/>
      <investor-summary  v-if="isVisible" :profile-summary="profileData" :saved-offering="savedOffering" :saved-doc-flow="savedDocFlow"></investor-summary>
    </div>
    <div class="clearfix"></div>
      <div>
          <investor-view v-if="isViewInvestorVisible" :filter="filter" :active-emd="activeEmd" :is-admin="isAdmin" :offering-list="offerings" :doc-flow-list="docFlows"></investor-view>
          <client-view v-if="isClientViewVisible" :filter="filter" :active-emd="activeEmd" :is-admin="isAdmin" :offering-list="offerings" :doc-flow-list="docFlows"></client-view>
          <investor-import :active-emd="activeEmd" v-if="isImportViewVisible"></investor-import>
      </div>
  </div>
</template>

<script>
import InvestorProfile from "./InvestorProfile";
import InvestorOffering from "./InvestorOffering";
import FieldError from "./FieldError";
import InvestorSummary from "./InvestorSummary";
import InvestorView from "./InvestorView";
import InvestorDocumentFlow from "./InvestorDocumentFlow";
import InvestorImport from "./InvestorImport.vue";
import ClientView from "./ClientView";

export default {

  components: {
    InvestorDocumentFlow,
    InvestorView,
    InvestorProfile,
    InvestorOffering,
    FieldError,
    InvestorSummary,
    ClientView,
    InvestorImport
  },
  props: {
    locale: Object,
    offerings: Array,
    docFlows: Array,
    filter: '',
    activeEmd: Object,
    isAdmin: Boolean,
  },
  data() {
    return {
      isVisible: false,
      isViewInvestorVisible: false,
      isClientViewVisible: false,
      isImportViewVisible: false,
      profileData: {
        id: 0,
        first_name: '',
        last_name: '',
        email: '',
      },
      savedOffering: {
        id: 0,
        name: '',
        slug: ''
      },
      savedDocFlow: {
        id: 0,
        name: '',
        slug: ''
      },
      inviteTo: '',
      offeringInviteVisible: false,
      documentInviteVisible: false,
    }
  },
  methods: {
    profile() {
      this.isVisible = !this.isVisible
      this.isViewInvestorVisible = false
      this.isClientViewVisible = false
      this.isImportViewVisible = false
    },
    viewInvestor() {
      this.isViewInvestorVisible = !this.isViewInvestorVisible
      this.isClientViewVisible = false
      this.isVisible = false
      this.isImportViewVisible = false
    },
    viewClient() {
      this.isClientViewVisible = !this.isClientViewVisible
      this.isViewInvestorVisible = false
      this.isVisible = false
      this.isImportViewVisible = false
    },
    viewImport() {
      this.isImportViewVisible = !this.isImportViewVisible
      this.isClientViewVisible = false
      this.isViewInvestorVisible = false
      this.isVisible = false
    },
    getProfileData(data) {
      this.profileData = data
    },
    getOfferingData(data) {
      this.savedOffering = data
      this.savedDocFlow.id = 0
      this.savedDocFlow.name = ''
      this.savedDocFlow.slug = ''
    },
    getDocFlowData(data) {
      this.savedDocFlow = data
      this.savedOffering.id = 0
      this.savedOffering.name = ''
      this.savedOffering.slug = ''
    },
    selectVisible() {
      if(this.inviteTo === 'offering') {
        this.offeringInviteVisible = true
        this.documentInviteVisible = false
      }
      if(this.inviteTo === 'docflow') {
        this.offeringInviteVisible = false
        this.documentInviteVisible = true
      }
    }
  }
}
</script>